module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('head-menu'), _vm._v(" "), _c('query-builder')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-560dfd08","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QueryEditor.vue
// module id = 229
// module chunks = 1